import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../components/ToastStyles/ToastStyles.css';
import { ImCross } from 'react-icons/im';
import { FaPlus, FaMinus } from 'react-icons/fa6';
import { getStockById } from '../Redux/features/Stock/stockSlice';
import { useDispatch } from 'react-redux';
import { ACTUAL_IMAGE_URL } from '../config/config';
import { getCartData, updateCart } from '../Redux/features/auth/authSlice';

const ProductDetail = ({ ArticleCode, closeModal }) => {
	const id = ArticleCode;

	const [quantity, setQuantity] = useState(1);

	const [ProductData, setProductData] = useState([]);

	const dispatch = useDispatch();

	useEffect(() => {
		// Dispatch the fetchStock action

		dispatch(getStockById(id)).then((data) => {
			setProductData(data.payload.stock);
		});
	}, [dispatch, id]);

	const handleIncrease = () => {
		if (ArticleCode && quantity < ProductData.StockQty) {
			setQuantity((prevQuantity) => prevQuantity + 1);
		}
	};

	const handleDecrease = () => {
		if (quantity > 1) {
			setQuantity((prevQuantity) => prevQuantity - 1);
		}
	};

	const handleAddToCart = async (ProductData) => {
		const product = {
			ArticleCode: ProductData.ArticleCode,
			Qty: quantity,
		};

		// Retrieve the cart data from localStorage
		let currentCart = JSON.parse(localStorage.getItem('CartData')) || [];

		// Check if the product already exists in the cart
		const existingProductIndex = currentCart.findIndex(
			(item) => item.ArticleCode === product.ArticleCode
		);

		// If the product exists, update the quantity; otherwise, add it to the cart
		if (existingProductIndex !== -1) {
			currentCart[existingProductIndex].Qty += product.Qty;
		} else {
			currentCart.push(product);
		}

		dispatch(updateCart({ updatedCart: currentCart })).then(() => {
			toast.success('Cart updated successfully');
			toast.success(
				existingProductIndex !== -1
					? 'Product quantity updated in the cart'
					: 'Successfully added to the cart'
			);
			localStorage.setItem('CartData', JSON.stringify(currentCart));
			dispatch(getCartData());
		});
	};

	if (!ProductData) {
		return <div>Product not found</div>;
	}

	return (
		<div className=' bg-white rounded-md  relative shadow-md'>
			<button
				onClick={closeModal}
				className=' absolute right-0 md:w-20 md:h-20 w-16 h-16 rounded-tr-md rounded-bl-full shadow-xl bg-red-500 hover:bg-red-600 transition-colors duration-300 text-center'>
				<ImCross className='text-white absolute md:right-5 right-4 md:text-lg text-base md:top-5 top-4 text-center' />
			</button>
			<div className=' overflow-y-auto custom-scrollbar'>
				<div className='flex md:flex-row gap-5 sm:p-5 p-3 flex-col max-md:h-[650px]  '>
					<div className='w-full  '>
						<img
							src={`${ACTUAL_IMAGE_URL}/${ProductData.ImagePath}`}
							alt={`Product ${ProductData.ProductName}`}
							className='lg:h-[610px] lg:w-[470px] md:h-[520px] md:w-[370px]  w-[280px] max-[300px]:w-[200px] rounded-lg shadow-md object-cover'
						/>
					</div>
					<div className='w-full'>
						<div className=' lg:h-[610px] lg:w-[520px] md:h-[520px] md:w-[380px]  w-[280px]  max-[300px]:w-[200px] border-[1px] rounded-sm  border-[#e3e3e3] max-sm:mb-5'>
							<div className=' sm:px-5 sm:py-6 px-2 py-4 '>
								<p className='md:text-3xl text-lg font-bold  lg:mb-2 mb-1 text-gray-600'>
									{ProductData.ProductName}
								</p>

								<p className='md:text-base text-sm lg:mb-3 mb-1 text-red-500 font-semibold'>
									Stock Quantity: {ProductData.StockQty}
								</p>
								{ProductData.StockQty === 0 ? (
									<p className='md:text-base text-sm lg:mb-3 mb-1 text-red-500 font-semibold'>
										Out of Stock
									</p>
								) : (
									<>
										<div className=' md:overflow-y-auto custom-scrollbar  pr-2 '>
											<p className='md:text-[15px] text-xs lg:h-32 md:h-20  sm:text-sm leading-relaxed text-justify '>
												<span className=' font-semibold text-gray-600'>Description :</span>{' '}
												{ProductData.ProductDescription}
											</p>
										</div>
										<div className='border-[1px] border-[#e3e3e3] lg:my-3 my-2   w-full' />

										<div className=''>
											<div className='relative '>
												<div className='flex gap-2 overflow-x-auto w-[400px] carousel'></div>
												<label>
													<span className=' font-semibold text-gray-600'>Color :</span>{' '}
													{ProductData.Color}
												</label>
											</div>
										</div>
										<div className='border border-[#e3e3e3] lg:my-4 my-2 w-full ' />
										<div className=''>
											<label className=' md:text-base text-sm lg:mb-3 mb-2'>
												<span className=' font-semibold text-gray-600'>Size :</span>{' '}
												{ProductData.Size}
											</label>
										</div>

										<div className='border border-[#e3e3e3] lg:my-4 my-2 w-full ' />
										<div className=''>
											<label className=' md:text-base text-sm lg:mb-3 mb-2 font-semibold text-gray-600'>
												<span className=' font-serif text-[16.75px] font-normal '>₹</span>
												{ProductData.DiscountMRP} <span></span> <span></span> MRP{' '}
												<span className=' font-medium line-through text-red-500 '>
													<span className=' font-serif text-[16.75px] '>₹</span>
													{ProductData.MRP}
												</span>
											</label>
										</div>

										<div className='border border-[#e3e3e3] lg:my-2 my-1 w-full ' />
										<label className=' md:text-base text-sm font-semibold text-gray-600 '>
											Add Quantity : {quantity}
										</label>
										<div className=' relative flex items-center justify-between  md:w-36 w-28 h-10 py-1 shadow-md border rounded-lg mt-1 '>
											<button
												onClick={handleDecrease}
												className=' absolute left-3 md:text-xs text-[10px] hover:text-red-500'>
												<FaMinus />
											</button>
											<div className='md:h-7 h-5 absolute md:left-10 left-7 border-[1px] border-black border-opacity-30 rounded-full ' />
											<input
												type='number'
												value={quantity}
												readOnly
												className='w-[50px] absolute md:left-14 left-[30px] text-center font-semibold text-sm outline-0'
											/>
											<div className='md:h-7 h-5 absolute md:right-10 right-8 border-[1px] border-black border-opacity-30 rounded-full' />
											<button
												onClick={handleIncrease}
												className=' absolute right-3 text-xs hover:text-red-500'>
												<FaPlus />
											</button>
										</div>

										<div className='border-[1px] border-[#e3e3e3] my-2  w-full ' />
										<p className='md:text-base text-sm  font-semibold md:mb-3 mb-2 '>
											<span className=' font-serif text-[16.75px] font-normal '>₹</span>
											{ProductData.DiscountMRP} × {quantity} ={' '}
											<span className=' font-serif text-[16.75px] font-normal '>₹</span>
											{(ProductData.DiscountMRP * quantity).toFixed(2)}
										</p>

										<div className='flex flex-row max-[300px]:flex-col justify-between items-center gap-5 '>
											<button
												onClick={() => handleAddToCart(ProductData)}
												className='md:w-2/5 w-full max-md:text-[10px] text-sm bg-red-500 text-white py-3 rounded-md font-semibold hover:bg-red-400'>
												Add to Cart
											</button>
											<button
												onClick={closeModal}
												className='md:w-2/5 w-full max-md:text-[10px] text-sm bg-red-500 text-white py-3 rounded-md font-semibold hover:bg-red-400'>
												Go To Dashboard
											</button>
										</div>
									</>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
			<ToastContainer
				position='top-right'
				autoClose={1000}
				hideProgressBar={true}
				closeOnClick
				pauseOnHover
				draggable
				pauseOnFocusLoss
				className=' mt-10'
			/>
		</div>
	);
};

export default ProductDetail;
